import { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Lecture (mise en cache) de la configuration publique du site (/site-config).
 * Sert notamment à savoir si le paiement en ligne est activé par le super admin.
 */
let cache = null;
let promise = null;

export function loadSiteConfig() {
  if (!promise) {
    promise = api
      .get("/site-config")
      .then(({ data }) => {
        cache = data || {};
        return cache;
      })
      .catch(() => {
        cache = { payment_enabled: true, cookie_consent_enabled: true };
        return cache;
      });
  }
  return promise;
}

// Permet de forcer un rechargement (ex. après modification côté admin).
export function refreshSiteConfig() {
  promise = null;
  return loadSiteConfig();
}

export function usePaymentEnabled() {
  const [enabled, setEnabled] = useState(cache ? cache.payment_enabled !== false : true);
  useEffect(() => {
    let active = true;
    loadSiteConfig().then((c) => active && setEnabled(c?.payment_enabled !== false));
    return () => {
      active = false;
    };
  }, []);
  return enabled;
}
